const InvestmentList = () =>
  import(/* webpackChunkName: "page-investment-list" */ '@/components/pages/investment/List.vue')
export default [
  {
    path: '',
    component: InvestmentList,
    name: 'investment-list',
    meta: {
      title: '売買用 - 事業・投資用物件一覧',
      type: 'list',
      requiresAuth: true,
    },
  },
]
